export default "__VITE_ASSET__ZaqfKahu__"